export default function(x) {
  return x === null ? NaN : +x;
}



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-array/src/number.js
// module id = ../../../../d3-array/src/number.js
// module chunks = 4